import React from 'react'
import {
    BackButton,
    BlocRenegoEdition,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue26() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Montant de l'opération"
                subTitle2="Saisissez les prêts bancaires à renégocier, et l'éventuel Prêt a Taux Zéro (PTZ) dont vous bénéficiez"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>
            <BlocRenegoEdition />
        </div>
    )
}
